/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qc_Fix_Gap_ToleranceInputs */



/**
* | output |
* | --- |
* | "Frame gap within tolerance range" |
*
* @param {Qc_Fix_Gap_ToleranceInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const qc_fix_gap_tolerance = /** @type {((inputs?: Qc_Fix_Gap_ToleranceInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qc_Fix_Gap_ToleranceInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Écart d'images dans la plage de tolérance")
	if (locale === "de") return /** @type {LocalizedString} */ ("Frame-Abstand im Toleranzbereich")
	if (locale === "it") return /** @type {LocalizedString} */ ("Intervallo di fotogrammi entro la tolleranza")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Интервал в пределах допуска")
	if (locale === "es") return /** @type {LocalizedString} */ ("Separación de fotogramas dentro del rango de tolerancia")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("帧间隔在容差范围内")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フレーム間隔が許容範囲内です")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़्रेम अंतराल सहनशीलता सीमा में है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Intervalo de fotogramas dentro da tolerância")
	return /** @type {LocalizedString} */ ("Frame gap within tolerance range")
});